import { RepresentativeData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class ConfidantList extends SimpleList<RepresentativeData> {
    protected readonly identifiableFieldName: string = 'ehrId';
}
